// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementLandingPagesAppGroupIdLandingPagePostIdResult = objectOf({
  info: string,
  landing_page_url: string,
  landing_page_bson_id: string,
});

export const isEngagementLandingPagesAppGroupIdLandingPagePutIdResult = objectOf({
  info: string,
});
